const ProductSkeleton = `<section class="skeleton-wrap">
<div style="background-color: white; display:flex;">
	<div style="display:flex;flex-direction: column;flex-grow: 1;margin-right: 15px;">
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
	</div>
	<div style="display:flex;flex-direction: column;flex-grow: 1;margin-right: 15px;">
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
	</div>
	<div style="display:flex;flex-direction: column;flex-grow: 1;margin-right: 15px;">
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
		<div class="skeleton" style="height: 7px;"></div>
	</div>
	
</div>
<div style="display:flex;justify-content:space-between">
	<div style="display:flex;flex-direction: column;width: 300px;">
		<div style="display:flex;">
			<div class="skeleton"style="width: 20px;"></div>
			<div class="skeleton"style="width: 120px;"></div>
			<div class="skeleton"style="width: 20px;"></div>
			<div class="skeleton"style="width: 120px;"></div>
		</div>
		<div style="display:flex;">
			<div class="skeleton"style="width: 20px;"></div>
			<div class="skeleton"style="width: 120px;"></div>
			<div class="skeleton"style="width: 20px;"></div>
			<div class="skeleton"style="width: 120px;"></div>
		</div>
		<div style="display:flex;">
			<div class="skeleton"style="width: 20px;"></div>
			<div class="skeleton"style="width: 120px;"></div>
			<div class="skeleton"style="width: 20px;"></div>
			<div class="skeleton"style="width: 120px;"></div>
		</div>
		<div style="display:flex;">
			<div class="skeleton"style="width: 20px;"></div>
			<div class="skeleton"style="width: 120px;"></div>
			<div class="skeleton"style="width: 20px;"></div>
			<div class="skeleton"style="width: 120px;"></div>
		</div>
	</div>
	<div style="display:flex;flex-direction: column;">
		<div class="skeleton"style="width: 120px;"></div>
		<div class="skeleton"style="width: 120px;"></div>
		<div class="skeleton"style="width: 120px;"></div>
		<div style="display:flex;align-items: flex-end;">
			<div class="skeleton"style="width: 120px;height: 40px; --color:var(--color-primary)"></div>
			<div class="skeleton"style="width: 120px;height: 40px;--color:#39a2f3"></div>
		</div>
	</div>
</div>
</section>`;
export default ProductSkeleton;
